import { h } from 'vue'
import type { FunctionalComponent } from 'vue'

const native = (tag: string): FunctionalComponent => (_props, { attrs, slots }) => h(tag, attrs, slots.default?.())

export const nativeProseComponents = {
    p: native('p'),
    strong: native('strong'),
    em: native('em'),
    ul: native('ul'),
    ol: native('ol'),
    li: native('li'),
    br: native('br'),
}
